// Fetch agentic signal suggestions for the current forecasting question from the
// server (POST /api/signals/suggest, gated on the signal-panel-suggestions flag).
// Returns { suggestions, autoSelect, autoSelectEnabled }:
//   suggestions        — [{ signalId, name, sublabel, reason, score }] to surface as chips.
//   autoSelect         — the confident subset the app should plot without a click
//                        (empty unless the signal-auto-select flag is on AND the
//                        question is obviously about specific signals).
//   autoSelectEnabled  — whether that flag is on, so the client can retire the
//                        legacy keyword auto-populate.
// Empty/false everywhere when the flags are off or anything fails, so callers can
// render/act unconditionally without special-casing the "off" state.
//
// Whether the suggestion SECTION is reserved (feature enabled at all) is a separate,
// boot-time decision sourced from /api/me's `signalSuggestionsEnabled` — not from
// this per-request response — so the drawer can reserve the section + show its
// loading skeleton before this request even resolves (no first-question layout shift).
//
// Deliberately fail-soft: any network/parse error resolves to the empty shape
// rather than throwing, matching the server's own degrade-to-empty behavior.

import { postSignalSuggest } from "../../services/signalsApi.js";

const EMPTY = {
  suggestions: [],
  autoSelect: [],
  autoSelectEnabled: false,
};

export async function suggestSignals(question, { limit, signal } = {}) {
  const q = (question || "").trim();
  if (!q) return { ...EMPTY };
  try {
    const r = await postSignalSuggest(limit ? { question: q, limit } : { question: q }, {
      signal,
    });
    if (!r.ok) return { ...EMPTY };
    const data = await r.json();
    return {
      suggestions: Array.isArray(data.suggestions) ? data.suggestions : [],
      autoSelect: Array.isArray(data.autoSelect) ? data.autoSelect : [],
      autoSelectEnabled: data.autoSelectEnabled === true,
    };
  } catch {
    return { ...EMPTY };
  }
}
